// @flow
import React, { type Node } from 'react'
import { Box, Cell, Row, Text } from 'sarsaparilla'

type Props = {
    containerProps: {},
    entranceLabel?: string,
    children: Node,
}

export default function AutoSuggestionEntranceContainer({
    containerProps,
    entranceLabel = 'Entrance Name',
    children,
}: Props) {
    return (
        <div
            {...containerProps}
            aria-label="suggestion header"
            role="searchbox"
            tabIndex={0}>
            <Box background="gray-2" className="pl-1">
                <Row>
                    <Cell width={8}>
                        <Text fontWeight="semibold">{entranceLabel}</Text>
                    </Cell>
                    <Cell width={2}>
                        <Text fontWeight="semibold">Area</Text>
                    </Cell>
                    <Cell width={2}>
                        <Text fontWeight="semibold">Code</Text>
                    </Cell>
                </Row>
            </Box>
            {children}
        </div>
    )
}
